
    import './styles.scoped.css';
    export default {
  "icon": "awsui_icon_h11ix_es97x_13",
  "icon-flex-height": "awsui_icon-flex-height_h11ix_es97x_21",
  "size-x-small": "awsui_size-x-small_h11ix_es97x_53",
  "size-x-small-mapped-height": "awsui_size-x-small-mapped-height_h11ix_es97x_56",
  "size-small": "awsui_size-small_h11ix_es97x_73",
  "size-small-mapped-height": "awsui_size-small-mapped-height_h11ix_es97x_76",
  "size-normal": "awsui_size-normal_h11ix_es97x_93",
  "size-normal-mapped-height": "awsui_size-normal-mapped-height_h11ix_es97x_96",
  "size-medium": "awsui_size-medium_h11ix_es97x_113",
  "size-medium-mapped-height": "awsui_size-medium-mapped-height_h11ix_es97x_116",
  "size-big": "awsui_size-big_h11ix_es97x_133",
  "size-big-mapped-height": "awsui_size-big-mapped-height_h11ix_es97x_136",
  "size-large": "awsui_size-large_h11ix_es97x_153",
  "size-large-mapped-height": "awsui_size-large-mapped-height_h11ix_es97x_156",
  "variant-normal": "awsui_variant-normal_h11ix_es97x_173",
  "variant-disabled": "awsui_variant-disabled_h11ix_es97x_176",
  "variant-inverted": "awsui_variant-inverted_h11ix_es97x_179",
  "variant-subtle": "awsui_variant-subtle_h11ix_es97x_182",
  "variant-warning": "awsui_variant-warning_h11ix_es97x_185",
  "variant-error": "awsui_variant-error_h11ix_es97x_188",
  "variant-success": "awsui_variant-success_h11ix_es97x_191",
  "variant-link": "awsui_variant-link_h11ix_es97x_194",
  "variant-info": "awsui_variant-info_h11ix_es97x_197",
  "name-angle-left-double": "awsui_name-angle-left-double_h11ix_es97x_200",
  "name-angle-left": "awsui_name-angle-left_h11ix_es97x_200",
  "name-angle-right-double": "awsui_name-angle-right-double_h11ix_es97x_202",
  "name-angle-right": "awsui_name-angle-right_h11ix_es97x_202",
  "name-arrow-left": "awsui_name-arrow-left_h11ix_es97x_204",
  "name-arrow-right": "awsui_name-arrow-right_h11ix_es97x_205",
  "name-caret-left-filled": "awsui_name-caret-left-filled_h11ix_es97x_206",
  "name-caret-right-filled": "awsui_name-caret-right-filled_h11ix_es97x_207",
  "name-audio-full": "awsui_name-audio-full_h11ix_es97x_208",
  "name-audio-half": "awsui_name-audio-half_h11ix_es97x_209",
  "name-audio-off": "awsui_name-audio-off_h11ix_es97x_210",
  "name-external": "awsui_name-external_h11ix_es97x_211",
  "name-redo": "awsui_name-redo_h11ix_es97x_212",
  "name-resize-area": "awsui_name-resize-area_h11ix_es97x_213",
  "name-send": "awsui_name-send_h11ix_es97x_214",
  "name-shrink": "awsui_name-shrink_h11ix_es97x_215",
  "name-undo": "awsui_name-undo_h11ix_es97x_216",
  "name-view-vertical": "awsui_name-view-vertical_h11ix_es97x_217",
  "name-gen-ai": "awsui_name-gen-ai_h11ix_es97x_595",
  "name-search-gen-ai": "awsui_name-search-gen-ai_h11ix_es97x_595",
  "name-edit-gen-ai": "awsui_name-edit-gen-ai_h11ix_es97x_595",
  "name-suggestions-gen-ai": "awsui_name-suggestions-gen-ai_h11ix_es97x_595",
  "name-copy": "awsui_name-copy_h11ix_es97x_595",
  "name-upload": "awsui_name-upload_h11ix_es97x_595",
  "name-download": "awsui_name-download_h11ix_es97x_595",
  "name-upload-download": "awsui_name-upload-download_h11ix_es97x_595",
  "name-sign-out": "awsui_name-sign-out_h11ix_es97x_595",
  "name-expand": "awsui_name-expand_h11ix_es97x_595",
  "name-full-screen": "awsui_name-full-screen_h11ix_es97x_595",
  "name-exit-full-screen": "awsui_name-exit-full-screen_h11ix_es97x_595",
  "name-remove": "awsui_name-remove_h11ix_es97x_595",
  "name-zoom-to-fit": "awsui_name-zoom-to-fit_h11ix_es97x_595",
  "name-multiscreen": "awsui_name-multiscreen_h11ix_es97x_595",
  "name-lock-private": "awsui_name-lock-private_h11ix_es97x_595",
  "name-unlocked": "awsui_name-unlocked_h11ix_es97x_595",
  "name-notification": "awsui_name-notification_h11ix_es97x_595",
  "name-history": "awsui_name-history_h11ix_es97x_595",
  "name-backward-10-seconds": "awsui_name-backward-10-seconds_h11ix_es97x_595",
  "name-forward-10-seconds": "awsui_name-forward-10-seconds_h11ix_es97x_595",
  "name-view-horizontal": "awsui_name-view-horizontal_h11ix_es97x_595",
  "name-zoom-in": "awsui_name-zoom-in_h11ix_es97x_595",
  "name-zoom-out": "awsui_name-zoom-out_h11ix_es97x_595",
  "name-menu": "awsui_name-menu_h11ix_es97x_595",
  "name-anchor-link": "awsui_name-anchor-link_h11ix_es97x_595",
  "name-convert-code": "awsui_name-convert-code_h11ix_es97x_595",
  "name-mini-player": "awsui_name-mini-player_h11ix_es97x_595",
  "name-treeview-expand": "awsui_name-treeview-expand_h11ix_es97x_595",
  "name-treeview-collapse": "awsui_name-treeview-collapse_h11ix_es97x_595",
  "name-view-full": "awsui_name-view-full_h11ix_es97x_595",
  "name-side-bar": "awsui_name-side-bar_h11ix_es97x_595",
  "name-bug": "awsui_name-bug_h11ix_es97x_595",
  "name-arrow-up": "awsui_name-arrow-up_h11ix_es97x_595",
  "name-arrow-down": "awsui_name-arrow-down_h11ix_es97x_595",
  "name-internal-link": "awsui_name-internal-link_h11ix_es97x_595",
  "name-delete-marker": "awsui_name-delete-marker_h11ix_es97x_595",
  "name-calendar": "awsui_name-calendar_h11ix_es97x_595",
  "name-call": "awsui_name-call_h11ix_es97x_595",
  "name-command-prompt": "awsui_name-command-prompt_h11ix_es97x_595",
  "name-contact": "awsui_name-contact_h11ix_es97x_595",
  "name-drag-indicator": "awsui_name-drag-indicator_h11ix_es97x_595",
  "name-edit": "awsui_name-edit_h11ix_es97x_595",
  "name-ellipsis": "awsui_name-ellipsis_h11ix_es97x_595",
  "name-envelope": "awsui_name-envelope_h11ix_es97x_595",
  "name-folder-open": "awsui_name-folder-open_h11ix_es97x_595",
  "name-globe": "awsui_name-globe_h11ix_es97x_595",
  "name-grid-view": "awsui_name-grid-view_h11ix_es97x_595",
  "name-insert-row": "awsui_name-insert-row_h11ix_es97x_595",
  "name-keyboard": "awsui_name-keyboard_h11ix_es97x_595",
  "name-light-dark": "awsui_name-light-dark_h11ix_es97x_595",
  "name-list-view": "awsui_name-list-view_h11ix_es97x_595",
  "name-location-pin": "awsui_name-location-pin_h11ix_es97x_595",
  "name-transcript": "awsui_name-transcript_h11ix_es97x_595",
  "name-announcement": "awsui_name-announcement_h11ix_es97x_601",
  "name-heart": "awsui_name-heart_h11ix_es97x_612",
  "icon-pulse-soft": "awsui_icon-pulse-soft_h11ix_es97x_1",
  "name-heart-filled": "awsui_name-heart-filled_h11ix_es97x_620",
  "icon-pulse-strong": "awsui_icon-pulse-strong_h11ix_es97x_1",
  "name-settings": "awsui_name-settings_h11ix_es97x_628",
  "name-thumbs-up": "awsui_name-thumbs-up_h11ix_es97x_639",
  "name-thumbs-up-filled": "awsui_name-thumbs-up-filled_h11ix_es97x_650",
  "name-thumbs-down": "awsui_name-thumbs-down_h11ix_es97x_661",
  "name-thumbs-down-filled": "awsui_name-thumbs-down-filled_h11ix_es97x_672",
  "name-face-happy-filled": "awsui_name-face-happy-filled_h11ix_es97x_683",
  "name-face-happy": "awsui_name-face-happy_h11ix_es97x_683",
  "icon-mouth-smile-grow": "awsui_icon-mouth-smile-grow_h11ix_es97x_1",
  "name-face-neutral": "awsui_name-face-neutral_h11ix_es97x_717",
  "icon-mouth-tilt": "awsui_icon-mouth-tilt_h11ix_es97x_1",
  "name-face-neutral-filled": "awsui_name-face-neutral-filled_h11ix_es97x_739",
  "name-face-sad": "awsui_name-face-sad_h11ix_es97x_750",
  "icon-mouth-frown-deepen": "awsui_icon-mouth-frown-deepen_h11ix_es97x_1",
  "name-face-sad-filled": "awsui_name-face-sad-filled_h11ix_es97x_773",
  "icon-sparkle-pinch": "awsui_icon-sparkle-pinch_h11ix_es97x_1",
  "icon-nudge-up": "awsui_icon-nudge-up_h11ix_es97x_1",
  "icon-nudge-down": "awsui_icon-nudge-down_h11ix_es97x_1",
  "icon-nudge-up-once": "awsui_icon-nudge-up-once_h11ix_es97x_1",
  "icon-nudge-down-once": "awsui_icon-nudge-down-once_h11ix_es97x_1",
  "icon-nudge-back": "awsui_icon-nudge-back_h11ix_es97x_1",
  "icon-shaft-retract": "awsui_icon-shaft-retract_h11ix_es97x_1",
  "icon-nudge-forward": "awsui_icon-nudge-forward_h11ix_es97x_1",
  "icon-nudge-up-right": "awsui_icon-nudge-up-right_h11ix_es97x_1",
  "icon-nudge-in": "awsui_icon-nudge-in_h11ix_es97x_1",
  "icon-nudge-down-left": "awsui_icon-nudge-down-left_h11ix_es97x_1",
  "icon-bell-rotate": "awsui_icon-bell-rotate_h11ix_es97x_1",
  "icon-ringer-bounce": "awsui_icon-ringer-bounce_h11ix_es97x_1",
  "icon-panel-slide-down": "awsui_icon-panel-slide-down_h11ix_es97x_1",
  "icon-panel-slide-right": "awsui_icon-panel-slide-right_h11ix_es97x_1",
  "icon-dot-blink": "awsui_icon-dot-blink_h11ix_es97x_1",
  "icon-nudge-right": "awsui_icon-nudge-right_h11ix_es97x_1",
  "icon-bar-slide-left": "awsui_icon-bar-slide-left_h11ix_es97x_1",
  "icon-gait-a": "awsui_icon-gait-a_h11ix_es97x_1",
  "icon-gait-b": "awsui_icon-gait-b_h11ix_es97x_1",
  "icon-glyph-nudge-up": "awsui_icon-glyph-nudge-up_h11ix_es97x_1",
  "icon-glyph-nudge-down": "awsui_icon-glyph-nudge-down_h11ix_es97x_1",
  "icon-glyph-nudge-left": "awsui_icon-glyph-nudge-left_h11ix_es97x_1",
  "icon-glyph-nudge-right": "awsui_icon-glyph-nudge-right_h11ix_es97x_1",
  "icon-handset-ring": "awsui_icon-handset-ring_h11ix_es97x_1",
  "icon-cursor-blink": "awsui_icon-cursor-blink_h11ix_es97x_1",
  "icon-meridian-turn": "awsui_icon-meridian-turn_h11ix_es97x_1",
  "icon-key-press": "awsui_icon-key-press_h11ix_es97x_1",
  "badge": "awsui_badge_h11ix_es97x_2307",
  "custom-icon": "awsui_custom-icon_h11ix_es97x_2321"
};
  